enum EnvTypeEnum {
    TEST = "https://apicz2-test.homecredit.cz/",
    PREPROD_CZ = "https://apicz2-test.homecredit.cz/",
    PREPROD_SK = "https://apicz2-test.homecredit.cz/",
    PROD_CZ = "https://api2.homecredit.cz/",
    PROD_SK = "https://api2.homecredit.sk/"
}

export default EnvTypeEnum;
